import React, { useState } from 'react'
import { isMobile, priceFormat } from '../../helpers/helpers';
import { CheckBox } from '../Forms/Forms';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import CONSTANTS from '../../Constants';

const ForfaitRegularItem = (props) => {
    const { forfait, forfaitFamilyCode } = props
    const selectedForfaitFromStore = useSelector(state => state.ndel_store.selectedForfaits)
    const [ShowDetail, setShowDetail] = useState(false)
    const [isChecked, setIsChecked] = useState(false)
    useEffect(() => {
        if (selectedForfaitFromStore.filter(item => item.Items[0].Ref === forfait.Items[0].Ref).length > 0) {
            forfait.isChecked = true
            forfait.forfaitFamilyCode = forfaitFamilyCode
            setIsChecked(true)
        }
    }, [])
    const onForfaitChecked = (e) => {
        forfait.isChecked = e.target.checked
        forfait.forfaitFamilyCode = forfaitFamilyCode
        props.addToCheckedForfaits(forfait)
        setIsChecked(e.target.checked)
    }
    const arrowDirectionClass = ShowDetail ? 'arrowUp' : 'arrowDown'
    return (
        <li className='forfait-item no-revisionConstructeur' >
            <div className='forfait-container'>
                <div className='forfait-block'>
                    <CheckBox name='forfaits' id={forfait.Items[0].Ref} label={forfait.Libelle} isChecked={isChecked} onClick={onForfaitChecked} />
                    {!isMobile() && <div className={`forfait-prix`}>{priceFormat(forfait.Items[0].Prix)} <span className="tax-text"> {CONSTANTS.LABELS.needs_basket_label2}</span></div>}
                    {forfait.Comments.length > 0 && <div tabIndex="0" className={`forfait-detail-link ${arrowDirectionClass}`} onClick={() => setShowDetail(!ShowDetail)} onKeyDown = {(e)=> e.key === 'Enter' && setShowDetail(!ShowDetail)}>{CONSTANTS.LABELS.common_v2_detail}</div>}
                </div>
                {ShowDetail && <div className='forfait-details'>
                    {forfait.Comments.map(comment => {
                        return (
                            <p key={comment.Order} className='detail'>{comment.Text}</p>
                        )
                    })}
                </div>}


                {isMobile() && <div className={`forfait-prix`}>{priceFormat(forfait.Items[0].Prix)} <span className="tax-text"> {CONSTANTS.LABELS.needs_basket_label2}</span></div>}
            </div>

        </li>
    );

}
export default ForfaitRegularItem